/**
 * Service worker registration with auto-update prompt.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  // Skip on local dev with HMR? Still register so we can test offline shell.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // New content available — auto-activate
              installing.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch((e) => console.warn("[SW] registration failed", e));
  });
}
